import { create, StateCreator } from 'zustand'
import { devtools, persist, createJSONStorage } from 'zustand/middleware'

import { IAppSessionState } from './appStore.types'


const initialState: IAppSessionState = {
    searchParams: {
        access_token: null,
        refresh_token: null,
        login_origin_domain: null,
    },
    showGlobalAlert: undefined,
}

export interface IAppSessionStore extends IAppSessionState {
    setSearchParams: (searchParams: Partial<IAppSessionState['searchParams']>) => void
    setShowGlobalAlert: (showGlobalAlert: boolean) => void

    reset: () => void
}

const createAppSessionStore: StateCreator<
    IAppSessionStore,
    [['zustand/persist', unknown], ['zustand/devtools', never]]
> = (set) => ({
    ...initialState,
    setSearchParams: (searchParams: Partial<IAppSessionState['searchParams']>) =>
        set(
            (state) => ({
                searchParams: {
                    ...state.searchParams,
                    ...searchParams,
                },
            }),
            undefined,
            'appSessionStore/setSearchParams'
        ),
    setShowGlobalAlert: (showGlobalAlert: boolean) =>
        set({ showGlobalAlert }, undefined, 'appSessionStore/setShowGlobalAlert'),
    
    reset: () => set({ ...initialState }, undefined, 'appSessionStore/reset'),
})

const useAppSessionStore = create<IAppSessionStore>()(
    persist(
        devtools(createAppSessionStore, { name: 'AppSessionStore' }),
        {
            name: 'app-session-store',
            storage: createJSONStorage(() => sessionStorage),
        }
    )
)

export default useAppSessionStore
